import { Divider } from '@vk-cloud-solutions/marketing-ui';

import { ContentBlockWrapper } from '~containers/ArticlePage/ContentBlockWrapper/ContentBlockWrapper';

import { ContentBlockDividerProps } from './ContentBlockDivider.types';

export function ContentBlockDivider({
  active,
  ...sectionProps
}: ContentBlockDividerProps) {
  return (
    <ContentBlockWrapper {...sectionProps}>
      {active && <Divider />}
    </ContentBlockWrapper>
  );
}
